/* eslint-disable react-hooks/rules-of-hooks */
import React, { DependencyList } from 'react'
import { Layer } from '@deck.gl/core/typed'
// @ts-ignore
import { DeckContextType } from 'src/types/deck'
import { browserLogger } from 'src/utils/browser-logger'

// uses the deckgl context either from the map editor or from google maps
export const useDeck = () => {
  return React.useContext(DeckContext)
}

const defaultContext = {
  setLayer: () => {},
  removeLayer: () => {},
  pickObject: () => {
    console.warn('no deck context')
  },
}

// shared deck context for both google maps and mapbox
export const DeckContext = React.createContext<DeckContextType>(defaultContext)

export function useLayer(layerFunc: () => Layer, params: DependencyList) {
  const deck = useDeck()
  React.useEffect(() => {
    deck.setLayer(layerFunc())
  }, params)
  React.useEffect(() => {
    return () => deck.removeLayer(layerFunc())
  }, [])
}

// mapbox has better deckgl integration, but for google maps this component
// must be mounted inside a map as a child and this component must be _outside_ any deck-gl layers
// because it provides the actual "deck" instance and google maps integration
export const GoogleMapsDeck = () => {
  browserLogger.warn('GoogleMapsDeck is deprecated')
  return null
}
